import DepartureRow from '../DepartureRow'
import { departures } from '../../data/departures'

export default function TrekDepartures({ trekSlug }) {
  const filtered = departures.filter(d => d.trekSlug === trekSlug)

  return (
    <div style={{ marginBottom: '60px' }}>
      <h2 className="section-title" style={{ fontSize: '24px', marginBottom: '24px' }}>Upcoming departures.</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {filtered.map(d => (
          <DepartureRow key={d.id} dep={d} />
        ))}
      </div>
    </div>
  )
}
